<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>配置</el-breadcrumb-item>
      <el-breadcrumb-item>需求分类管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :inline="true"
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          @submit.native.prevent
          size="small"
        >
          <el-form-item label="分类名称" prop="query">
            <el-input
              v-model="filter.query"
              placeholder="分类名称"
              @keyup.enter.native="requestCategories"
            ></el-input>
          </el-form-item>
          <el-form-item label="分类级别" prop="level">
            <el-select v-model="filter.level">
              <el-option label="一级分类" :value="1" :key="1"></el-option>
              <el-option label="二级分类" :value="2" :key="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestCategories()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <Table :filter="params"></Table>
    </div>
  </div>
</template>
<script>
import Table from './table'

export default {
  components: {
    Table,
  },
  data() {
    return {
      filter: {
        query: '',
        level: '',
      },
      params: {
        query: '',
        level: '',
        size: 1000,
        page: 1,
      },
    }
  },
  methods: {
    requestCategories() {
      let data = this.params
      data.query = this.filter.query
      data.level = this.filter.level
      this.params = data
    },
    reset() {
      this.params.page = 1
      this.$refs['filterForm'].resetFields()
      this.requestCategories()
    },
  },
}
</script>